import React from 'react';
import { Box, Skeleton, TableCell, TableRow } from '@mui/material';
import { parentPortalTheme } from '../theme/parentPortalTheme';

interface ParentPortalTablePreloaderProps {
  columns: number;
  rows?: number;
}

const ParentPortalTablePreloader: React.FC<ParentPortalTablePreloaderProps> = ({ columns, rows = 4 }) => (
  <>
    {Array.from({ length: rows }, (_, rowIndex) => (
      <TableRow key={rowIndex} sx={{ bgcolor: rowIndex % 2 ? parentPortalTheme.skeleton.rowAlt : '#fff' }}>
        {Array.from({ length: columns }, (_, columnIndex) => (
          <TableCell key={columnIndex}>
            <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 36 }}>
              <Skeleton
                variant={columnIndex === columns - 1 ? 'rounded' : 'text'}
                width={columnIndex === columns - 1 ? 96 : `${70 + ((rowIndex + columnIndex) % 3) * 10}%`}
                height={columnIndex === columns - 1 ? 32 : 24}
                sx={{
                  borderRadius: columnIndex === columns - 1 ? 999 : 2,
                  bgcolor: parentPortalTheme.skeleton.shimmer,
                  '&::after': {
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.65), transparent)',
                  },
                }}
              />
            </Box>
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export default ParentPortalTablePreloader;
